import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import BusinessOutlined from "@mui/icons-material/BusinessOutlined";
import EditOutlined from "@mui/icons-material/EditOutlined";

const VARIANTS = {
  booking: { icon: BusinessOutlined, label: "Booking note", accent: "primary.main", bg: (t) => alpha(t.palette.primary.main, 0.08) },
  trainer: { icon: EditOutlined, label: "Your note", accent: "text.secondary", bg: "action.hover" }
};

function NoteCallout({ variant, text, sx }) {
  const { icon: Icon, label, accent, bg } = VARIANTS[variant];
  return (
    <Box sx={{ p: 1.25, borderRadius: 2, display: "flex", gap: 1, bgcolor: bg, ...sx }}>
      <Icon sx={{ fontSize: "1.375rem", color: accent, mt: 0.25, flexShrink: 0 }} />
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="caption" sx={{ display: "block", fontWeight: 700, color: accent, textTransform: "uppercase", letterSpacing: 0.4 }}>
          {label}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "pre-wrap" }}>
          {text}
        </Typography>
      </Box>
    </Box>
  );
}

export default NoteCallout;
